import { render, staticRenderFns } from "./addwelfareClass.vue?vue&type=template&id=7aab8b80&scoped=true&"
import script from "./addwelfareClass.vue?vue&type=script&lang=js&"
export * from "./addwelfareClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aab8b80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aab8b80')) {
      api.createRecord('7aab8b80', component.options)
    } else {
      api.reload('7aab8b80', component.options)
    }
    module.hot.accept("./addwelfareClass.vue?vue&type=template&id=7aab8b80&scoped=true&", function () {
      api.rerender('7aab8b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/welfareClass/components/addwelfareClass.vue"
export default component.exports